module.exports = __webpack_public_path__ + "static/media/BY.9b416588.png";